import { createRouter, createWebHistory, isNavigationFailure } from 'vue-router'
import Home from '../views/Home.vue'
import {isAuthenticated} from '../services/auth';
import {getItem} from '@/services/localdb';
import vitrineApi from '@/services/vitrineApi';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Veículos'
    }
  },
  {
    path: '/minhas-ofertas',
    name: 'Offers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Offers.vue'),
    meta: {
      title: 'Minhas Ofertas'
    }
  },
  {
    path: '/preferencias',
    name: 'Preferences',
    component: () => import('../views/Preferences.vue'),
    meta: {
      title: 'Preferências'
    }
  },
  {
    path: '/notificacoes',
    name: 'Notifications',
    component: () => import('../views/Notifications.vue'),
    meta: {
      title: 'Notificações'
    }
  },
  {
    path: '/detalhes/:id',
    name: 'Details',
    component: () => import('../views/Details.vue'),
    meta: {
      title: 'Detalhes do veículo'
    }
  },
  {
    // pagina publica do veiculo, aberta pelo link com token (sem login)
    path: '/v/:token',
    name: 'PublicVehicle',
    component: () => import('../views/PublicVehicle.vue'),
    meta: {
      title: 'Anúncio de veículo',
      public: true,
    }
  },
  {
    // vitrine publica do tenant (sem login); as views definem o proprio titulo
    path: '/vitrine',
    name: 'Vitrine',
    component: () => import('../views/Vitrine.vue'),
    meta: {
      title: 'Veículos à venda',
      public: true,
      tituloProprio: true,
    }
  },
  {
    path: '/vitrine/:codigo',
    name: 'VitrineVeiculo',
    component: () => import('../views/VitrineVeiculo.vue'),
    meta: {
      title: 'Veículo à venda',
      public: true,
      tituloProprio: true,
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/External.vue'),
    meta: {
      title: 'Faça o login ou solicite um cadastro',
      allowAnnonymous: true,
    }
  },
  {
    path: '/recuperar-senha/:id',
    name: 'Recovery',
    component: () => import('../views/External.vue'),
    meta: {
      title: 'Recuperação de senha',
      allowAnnonymous: true,
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 ,behavior: 'smooth',}
  },
})

// Função para detectar dispositivo móvel
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

function tentarAbrirApp(codigoNegociacao) {
  let company = JSON.parse(getItem('company') || false);

  if(company && company.iosDownloadLink) {
    console.log('tentando abrir app..')
    const deepLinkPorHost = location.host.substring(0,location.host.indexOf('.'))  || 'app';

    // Tentar abrir o deep link para a rota de detalhes se o referrer for externo
    const deepLink = `${deepLinkPorHost}://home/${codigoNegociacao}`;
    window.location.href = deepLink;  
  }
}
// Visitante sem login numa rota que exige login: o fluxo de sempre (tenta abrir o app no celular e vai para o login).
function fluxoSemLogin(to, from, next) {
  // Verificar se o usuário veio de um link externo, ou estava navegando no site
  const isExternalReferrer = typeof(from.name) === 'undefined';

  if(isMobileDevice() && 
      to.fullPath.includes('detalhes') && isExternalReferrer) {
    tentarAbrirApp(to.params.id);
  } 
  
  // redirecionar para tela de login
  setTimeout(() => {
    next({
      name: 'Login',
      query: { redirect: to.fullPath },
    });
  }, 1500); // 1.5 segundos de timeout
}

router.beforeEach((to, from, next) => {
  const isAuth = isAuthenticated();

  if (!isAuth && !to.matched.some(record => record.meta.allowAnnonymous || record.meta.public)) {
    // Visitante na raiz: com a vitrine do tenant ligada, vai para ela; desligada ou com erro, o fluxo de sempre.
    if (to.name === 'Home') {
      vitrineApi.config()
        .then(config => (config && config.ativo ? next({ name: 'Vitrine' }) : fluxoSemLogin(to, from, next)))
        .catch(() => fluxoSemLogin(to, from, next));
      return;
    }
    fluxoSemLogin(to, from, next);
  }
  else {
    next();
  }
});

router.afterEach((to, from) => {
      
  let company = JSON.parse(getItem('company') || 'null');

  let param = company?.parametros?.find(p=>p.chave === 'empresa.nome');
  let nome = param?.valor || company?.nomeFantasia;

  let companyName = nome ? `${nome} - ` : '';
  // as telas da vitrine montam o proprio titulo (loja e veiculo) depois de carregar
  if (!to.meta.tituloProprio) document.title = `${companyName}${to.meta.title || ''}`;

  if (to.name === 'Details'
    //&& isMobileDevice()
  ) {
    // Verificar se o usuário veio de um link externo, ou estava navegando no site
    const isExternalReferrer = typeof(from.name) === 'undefined';

    isExternalReferrer && tentarAbrirApp(to.params.id); // Chama a função após a navegação ser confirmada
  } 
});

export default router;
